import * as z from "zod/v4";

export const getShopifySegments = {
  name: "getShopifySegments" as const,
  input: z.object({}),
  output: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      query: z.string(),
      creationDate: z.string(),
      lastEditDate: z.string(),
    }),
  ),
};
